export default __webpack_public_path__ + "static/media/landing_section_img_2.2759fac3.png";